import React from 'react'
import 'styled-components/macro'
import { styled } from 'styled-components'

interface Props {
	color: 'success' | 'error' | 'default'
	opacity?: string
	width?: number
	height?: number
	ratio?: number
}

//This component creates a Position icon that is used in Image Labeling student view.
export default function Position(props: Props): JSX.Element {
	const {
		color = 'default',
		opacity = '1',
		width = 49,
		height = 59,
		ratio = 1,
	} = props
	return (
		<PositionSvg
			width={width / ratio}
			height={height / ratio}
			viewBox={`0 0 ${width} ${height}`}
			fill="none"
			$color={color}
			xmlns="http://www.w3.org/2000/svg">
			<g filter="url(#filter0_d_121_4)">
				<path
					className="path-icon"
					d="M13.2486 4.66114C8.94437 7.75772 6.01992 12.4014 5.11679 17.5735C4.21367 22.7456 5.40561 28.0239 8.43116 32.2504C10.9026 35.7051 14.462 38.2371 18.5632 39.4582C18.5632 39.4582 19.4168 39.7121 19.5484 39.7427L42.3461 45.2056L44.4686 21.8473C44.4785 21.7239 44.5137 20.8343 44.5137 20.8343L44.5121 20.8289C44.6679 16.5546 43.4089 12.3739 40.9284 8.9282C37.8927 4.70896 33.2737 1.89021 28.0846 1.09027C22.8955 0.290334 17.5601 1.57452 13.2486 4.66114Z"
					opacity={opacity}
				/>
				<path
					d="M10.0578 31.0867L10.0574 31.0863C7.3477 27.3009 6.27509 22.5672 7.08698 17.9175C7.89907 13.2668 10.5311 9.0807 14.4147 6.286C18.3055 3.50127 23.1139 2.34762 27.7799 3.06693C32.4448 3.78606 36.5861 6.31746 39.3049 10.0963L39.3052 10.0967C41.5241 13.179 42.6531 16.9222 42.5134 20.756L42.5012 21.0902L42.5016 21.0916C42.5 21.13 42.4984 21.1699 42.4967 21.2102C42.4917 21.3281 42.4865 21.4475 42.482 21.5439C42.4778 21.635 42.4754 21.6783 42.4749 21.6871L40.5635 42.7218L20.0145 37.7977L20.0145 37.7977L20.0012 37.7946C20.0027 37.795 19.9909 37.7916 19.9673 37.7848C19.9055 37.7672 19.763 37.7265 19.5685 37.6695C19.4559 37.6366 19.347 37.6044 19.266 37.5805L19.1692 37.5518L19.1425 37.5439L19.1356 37.5418L19.1339 37.5413L19.1339 37.5413C15.4551 36.446 12.2686 34.1771 10.0578 31.0867Z"
					stroke="white"
					strokeWidth="4"
				/>
			</g>
			<defs>
				<filter
					id="filter0_d_121_4"
					x="0.822137"
					y="0.85791"
					width="47.7028"
					height="52.3477"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB">
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy="4" />
					<feGaussianBlur stdDeviation="2" />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
					/>
					<feBlend
						mode="normal"
						in2="BackgroundImageFix"
						result="effect1_dropShadow_121_4"
					/>
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect1_dropShadow_121_4"
						result="shape"
					/>
				</filter>
			</defs>
		</PositionSvg>
	)
}
interface SvgProps {
	$color: 'success' | 'error' | 'default'
}
const PositionSvg = styled.svg<SvgProps>`
	overflow: visible;
	pointer-events: none;
	.path-icon {
		fill: ${({ $color, theme }) => {
			return $color === 'success'
				? theme.success
				: $color === 'error'
				? theme.error
				: '#AB0586'
		}}
`
